import { render, staticRenderFns } from "./InformationSpace.vue?vue&type=template&id=5aee17c9&scoped=true"
import script from "./InformationSpace.vue?vue&type=script&lang=js"
export * from "./InformationSpace.vue?vue&type=script&lang=js"
import style0 from "./InformationSpace.vue?vue&type=style&index=0&id=5aee17c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aee17c9",
  null
  
)

export default component.exports